import { AddLicenseVersion, AddLicenseVersionApi } from '../../../../domainModels/licenceVersions/AddLicenseVersion';
import { PaymentStatus, mapPaymentStatusToApiModel } from '../../../../domainModels/licences/PaymentStatus';
import { dateToApiDateStringFormat } from '../../../../helpers/moment';

export const addLicenseVersionModelToApi = (model: AddLicenseVersion): AddLicenseVersionApi => ({
    ...model,
    paymentDeadline: dateToApiDateStringFormat(model.paymentDeadline),
    validFrom: dateToApiDateStringFormat(model.validFrom),
    validTo: dateToApiDateStringFormat(model.validTo),
    paymentStatus: mapPaymentStatusToApiModel(model.paymentStatus) || PaymentStatus.Awaiting,
    includeBeta: model.includeBeta || false,
});
